import type { ProductListMediaCard } from '~/types/storyblok/product-list-media-card'
import type { Story } from '~/types/vendors/storyblok'

export function useProductMediaCards(productListMediaCards: Story<ProductListMediaCard>[] | undefined, options: {
  smallGrid: Ref<boolean>
}) {
  const hideMediaCards = computed(() => options.smallGrid.value)
  const productListMediaCardsPosition = [4, 20, 36, 52]

  type CardIndex = 0 | 1 | 2 | 3
  type CardPosition = 4 | 20 | 36 | 52

  const cardTable: Record<CardPosition, CardIndex> = {
    4: 0,
    20: 1,
    36: 2,
    52: 3,
  }

  const cardMapper = (cardPosition: CardPosition): CardIndex => cardTable[cardPosition]

  function shouldShowMediaCard(index: number) {
    if (hideMediaCards.value)
      return false

    return productListMediaCardsPosition.includes(index as CardIndex)
  }

  function getMediaCardContent(index: number) {
    const cardIndex = cardMapper(index as CardPosition)
    return productListMediaCards?.[cardIndex]?.content
  }

  return {
    shouldShowMediaCard,
    getMediaCardContent,
  }
}
